<template>
    <div class="language-indicator">
        <NavigationTabItem :tab="navigationTabProps" :hide-collapse-on-full="true" header-menu />
        <LocaleSelection ref="localeSelectionDialog" :hide-dialog-triger="true" />
    </div>
</template>

<script setup lang="ts">
    import {computed, ref} from 'vue';
    import GlobeIcon from '@navbar-common/icons/GlobeIcon.vue';
    import type {NavigationTab} from '@navbar-logged/features/aside-menu';
    import {NavigationTabItem} from '@navbar-logged/features/aside-menu';
    import {storeToRefs} from 'pinia';
    import {LocaleSelection} from '#components';
    import {useLanguageSelectorStore} from '../language-selector.store';

    // Stores
    const languageSelectorStore = useLanguageSelectorStore();
    const {selectedLanguage} = storeToRefs(languageSelectorStore);

    // Refs
    const localeSelectionDialog = ref<InstanceType<typeof LocaleSelection>>();

    // Computed values
    const navigationTabProps = computed<NavigationTab>(() => ({
        showTitleAlways: true,
        id: 'Language',
        title: selectedLanguage.value.language.toUpperCase(),
        icons: {mainIcon: GlobeIcon},
        action: () => {
            localeSelectionDialog.value?.dialog?.show();
        },
    }));
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .language-indicator {
        flex: none;
    }
</style>
